// extracted by mini-css-extract-plugin
export default {"faqAppsInstall":"faqAppsInstall_KP4al","container":"container_XtwQ8","title":"title_D6szY","description":"description_sN1Ix","apps":"apps_szAOs","qr":"qr_kTQZX"};